var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.637512 12C0.637512 16.9125 3.78751 21.075 8.13751 22.6125V1.38751C3.78751 2.92501 0.637512 7.08751 0.637512 12Z",
    fill: "#75A843"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1375 12C23.1375 7.08751 19.9875 2.92501 15.6375 1.38751V22.6125C20.025 21.075 23.1375 16.9125 23.1375 12Z",
    fill: "#ED4C5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13751 22.6125C9.30001 23.025 10.575 23.25 11.8875 23.25C13.2 23.25 14.475 23.025 15.6375 22.6125V1.3875C14.475 0.975 13.2 0.75 11.8875 0.75C10.575 0.75 9.30001 0.975 8.13751 1.3875V22.6125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaly);
export default __webpack_public_path__ + "static/media/italy.2ac8d010a3677eb87c28694594a6f7bb.svg";
export { ForwardRef as ReactComponent };